import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C33IconCTALeftAlignedProps } from './C33IconCTALeftAligned';
import { C33IconCTALeftAlignedCardProps } from './C33IconCTALeftAlignedCard';
import {
  IconCtaLeftAlignedCardProps,
  IconCtaLeftAlignedProps,
} from '@ahc-digital/component-library';
import { ICON_CTA_LEFT_ALIGNED_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function CreateIconCTALeftAlignedModel(
  props?: C33IconCTALeftAlignedProps
): IconCtaLeftAlignedProps {
  type t = IconCtaLeftAlignedProps;
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();
  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    bottomSupportCopy: renderRichText(fields?.BottomSupportCopy),
    children: rendering && <Placeholder name={ICON_CTA_LEFT_ALIGNED_CARDS} rendering={rendering} />,
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'p'),
    numberOfColumns: getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '2'),
    supportCopyAlignment: getDroplink<t['supportCopyAlignment']>(
      params?.SupportCopyAlignment,
      'center'
    ),
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.TitleAlignment, 'center'),
  };
}

export function CreateIconCTALeftAlignedCardModel(
  props?: C33IconCTALeftAlignedCardProps
): IconCtaLeftAlignedCardProps {
  type t = IconCtaLeftAlignedCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderText, renderLink } = useConditionalRendering();

  return {
    icon: props?.fields?.Icon?.fields?.Value?.value as t['icon'],
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'p'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    cardCTA: renderLink(fields?.CardCTA),
  };
}
